export default class TileSprite extends Phaser.Sprite {
  constructor (game, x, y, key, frame) {
    super(game, x, y, key, frame)

    this.tileX = Math.floor(x / TILE_WIDTH)
    this.tileY = Math.floor(y / TILE_HEIGHT)
  }

  registerValues (objectValues) {
    this.values = {
      position: objectValues.next(0xff0000)
    }

    this.values.position.set(this.hexCoords())
    this.values.position.watch((hexCoords) => {
      try {
        this.place(hexCoords % 16, Math.floor(hexCoords / 16))
        this.values.positionValue.set(this.values.position.getIndirect())
      } catch (e) {
        // there's not enough time for this error to matter
      }
    })
  }

  place (tileX, tileY) {
    if (this.moving) {
      return
    }

    this.tileX = tileX
    this.tileY = tileY
    this.x = tileX * TILE_WIDTH
    this.y = tileY * TILE_HEIGHT

    this.values.position.set(this.hexCoords())
  }

  hexCoords () {
    return this.tileY * 16 + this.tileX
  }

  wouldCollide (tileXDest, tileYDest) {
    return (this.collidable && this.tileX === tileXDest && this.tileY === tileYDest)
  }
}
